import { atom } from 'jotai'
import { alphamapClient } from 'src/clients'
import { selectedParcel } from 'src/v2/state/owner-reveal/sidebar'

export const parcelOwners = atom(async (get) => {
  const _selectedParcel = await get(selectedParcel)

  if (!_selectedParcel) {
    return undefined
  }

  const ownerIds = _selectedParcel.owners.map((owner) => owner.id)
  if (ownerIds.length === 0) {
    return undefined
  }
  return await alphamapClient.ownership.getEntitiesByIds(ownerIds)
})
